module.exports = __webpack_public_path__ + "giving/public/shared/assets/mastercard.svg?918afd3c1af1c3c48517f4cdc1c3b617";